import React, { useEffect, useState } from "react";
import FetchCharts from 'utils/fetch/FetchCharts'
import _ from 'lodash'
import LoadingComponent from 'components/atoms/Loading'
import Text from "theme/Text";
import { textStyles } from 'styles/text'
import i18n from 'utils/i18n'
import ThemedBlock from 'components/atoms/ThemedBlock'
import WebView from 'components/atoms/WebView'
import HelperString from 'utils/helper-string'
import GraphContainer from 'components/atoms/GraphContainer'
import { GraphVariables } from 'components/management/molecules/graphs'

const GraphBookingPresenceDayChart = ({ dateRange, building, floor, room, team, employee } = {} ) => {
	
	const [ chart, setChart ] = useState( null )
	const [ data, setData ] = useState( null )
	
	useEffect(() => {
		FetchCharts.fetchBookingsPresentDay({
			variables: GraphVariables({
				dateRange, building, floor, room, team, employee
			}),
			callbackSuccess: ( chart ) => {
				setChart( chart )
				setData( _.isEmpty( chart.data ) ? false : JSON.parse( chart.data ) )
			}
		} );
	}, dateRange )
	
	let title = null;
	let content = (
		<LoadingComponent />
	);
	
	if( chart !== null ) {
		content = (
			<ThemedBlock transparent mediumPadding>
				<Text style={ textStyles.textCenter }>
					{ i18n.t( 'management:generic.no_results' ) }
				</Text>
			</ThemedBlock>
		)
		
		if( !_.isEmpty( chart ) ) {
			title = chart.name;
			
			content = (
				<WebView
					key={ HelperString.hash( 'webview', dateRange ) }
					html={ chart.html }
				/>
			)
		}
	}
	
	return (
		<GraphContainer
			chart={ chart }
			title={ title }>
			
			{ content }
		</GraphContainer>
	)
}

export default GraphBookingPresenceDayChart
